export default function Eyebrow({ children, tone = "terracotta", className = "" }) {
  const tones = {
    terracotta: "text-terracotta",
    gold: "text-gold",
    cream: "text-cream/70",
    charcoal: "text-charcoal/60",
  };
  return (
    <p
      className={`text-[11px] md:text-xs uppercase tracking-[0.28em] font-medium ${tones[tone]} ${className}`}
    >
      {children}
    </p>
  );
}
